<template>
  <div>
    <landscape-warning v-show="showLandscapeWarning" class="landscape-card--warning" />
    <div class="camera-layout--container" :class="{'camera-layout__loading': loading }">
      <div class="camera-layout--header">
        <p class="body-semi-bold">{{ headerTitle }}</p>
      </div>

      <div class="camera-layout--video">
        <div class="warning-message" :class="{'hidden': !showWarningMessage }">
          <p class="body-semi-bold white">{{ warningMessage }}</p>
        </div>
        <onboarding-camera
          v-show="!usingPicture"
          ref="onboarding-camera"
          @onStart="handleStartCamera"
          @onError="handleCameraError"
        />
      </div>

      <div class="camera-layout--footer">
        <div @click="takePicture" class="take-picture--button">
          <camera-icon size="32" color="#FFFFFF" />
        </div>
      </div>
    </div>

    <onboarding-loading
      v-if="loading"
      ref="onboarding-loading"
      :loadingMessage="loadingMessage"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { CameraIcon } from '@vue-hero-icons/outline';
import OnboardingCamera from './Camera.vue';
import OnboardingLoading from './OnboardingLoading.vue';
import LandscapeWarning from './LandscapeWarning.vue';

export default {
  name: 'v2-onboarding-camera-layout',
  data: () => ({
    showWarningMessage: false,
    documentStep: null,
    loading: true,
    loadingMessage: null,
    usingPicture: null,
  }),
  watch: {
    warningMessage() {
      this.handleStartCamera();
    },
  },
  props: {
    openCamera: {
      type: Boolean,
      required: true,
    },
    headerTitle: {
      type: String,
      required: true,
    },
    warningMessage: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('onboardingV2', ['showLandscapeWarning']),
  },
  methods: {
    handleCameraError(error) {
      this.$emit('onCameraError', error);
    },
    handleStartCamera() {
      this.loading = false;
      this.showWarningMessage = true;
      setTimeout(() => {
        this.showWarningMessage = false;
      }, 2500);
    },
    async takePicture() {
      if (this.showWarningMessage) return;
      this.loading = true;
      this.loadingMessage = 'Enviando...';
      const base64Image = await this.$refs['onboarding-camera'].takePicture();
      this.$emit('onTakePicture', base64Image);
      this.usingPicture = true;
    },
    async stopLoading({ success, timeout, message }) {
      await this.$refs['onboarding-loading'].stopLoading({ success, timeout, message });
      this.loading = false;
      this.loadingMessage = false;
      if (this.usingPicture) this.usingPicture = false;
    },
    closeCamera() {
      this.$refs['onboarding-camera'].closeCamera();
    },
  },
  async mounted() {
    if (this.openCamera) await this.$refs['onboarding-camera'].openCamera();
  },
  components: {
    OnboardingCamera,
    CameraIcon,
    OnboardingLoading,
    LandscapeWarning,
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .camera-layout--container {
    display: grid;
    grid-template-rows: 72px 1fr 128px;
    grid-template-columns: 1fr;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
  }

  .camera-layout--header {
    p {
      @extend .body-semi-bold;
      @extend .gray-900;
      padding: 22px 24px;
    }
  }

  .camera-layout--video {
    position: relative;
    height: 100%;

    .warning-message {
      z-index: 9999;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.7);
      height: 100%;
      width: 100%;

      p {
        width: calc(100% - 48px);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
      }

      &.hidden {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s 1s, opacity 1s linear;
      }
    }
  }

  .camera-layout--footer {
    display: flex;
    justify-content: center;
    align-items: center;

    .take-picture--button {
      background-color: $primary-500;
      border-radius: 50%;
      padding: 16px;
      width: 64px;
      height: 64px;

      &:active {
        background-color: $primary-600;
      }
    }
  }

  .camera-layout__loading {
    -webkit-filter: blur(16px);
    -moz-filter: blur(16px);
    -o-filter: blur(16px);
    -ms-filter: blur(16px);
    filter: blur(16px);
  }
</style>
